import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { CampaniaDctoCiclos } from '../_models/campania-dcto-ciclos';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CampaniaDctoCicloService {

  private rutaServicio = AppSettings.rutServiciosAPL + '/api/campaniaDctoCiclos';

  constructor( private httClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listadoCampaniasDctoCiclos() {
    return this.httClient.get( this.rutaServicio ).pipe( map( res => res as CampaniaDctoCiclos[] ) );
  }

  listadoCampaniasDctoCiclosHabilitadas() {
    return this.httClient.get( this.rutaServicio + '/enabled' ).pipe( map( res => res as CampaniaDctoCiclos[] ) );
  }

  listadoCampaniasDctoCiclosIdCampania(id: string) {
    return this.httClient.get( this.rutaServicio + '/campania/' + id + '/findAll' ).pipe( map( res => res as CampaniaDctoCiclos[] ) );
  }

  listadoCampaniasDctoCiclosHabilitadasIdCampania(id: string) {
    return this.httClient.get( this.rutaServicio + '/campania/' + id ).pipe( map( res => res as CampaniaDctoCiclos[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httClient.get( this.rutaServicio + '/' + id ).pipe( map( res => res as CampaniaDctoCiclos ) );
  }

  crear( campaniaDctoCiclos: CampaniaDctoCiclos ) {
    campaniaDctoCiclos.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutaServicio, campaniaDctoCiclos ).pipe( map( res => res as CampaniaDctoCiclos ) );
  }

  actualizar( campaniaDctoCiclos: CampaniaDctoCiclos ) {
    campaniaDctoCiclos.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutaServicio, campaniaDctoCiclos ).pipe( map( res => res as any ) );
  }


}
